import { Button } from "@jobber/components/Button";
import { Menu } from "@jobber/components/Menu";
import { Text } from "@jobber/components/Text";
import { useUserContext } from "@/contexts";
import { redirectToJobber, removeFromLocalStorage } from "@/helpers";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "@/services";
import styles from "./Settings.module.scss";
import { getDistance } from "@/pages/MatcherPage/schedulingLogic";
import {trpc} from "@/services/trpc";
import { getSyncedAtType } from "@/services/trpc/types";

const Settings = () => {
  const { user } = useUserContext();
  const navigate = useNavigate();
  const syncMutation = trpc.settings.syncWithJobber.useMutation()
  const syncedAtQuery = trpc.settings.getSyncedAt.useQuery() as getSyncedAtType
  const loading = useCallback(() => {
    return syncMutation.isPending || syncedAtQuery.isPending
  }, [syncMutation.isPending, syncedAtQuery.isPending]);
  const handleLogout = useCallback(async () => {
    try {
      await logout();
      removeFromLocalStorage("user");
      redirectToJobber();
    } catch (error) {
      navigate("/auth");
    }
  }, [navigate]);
  const handleSyncClick = useCallback(async () => {
    syncMutation.mutate(undefined, {
      onSuccess: async () => {
        await syncedAtQuery.refetch()
      }
    })
  }, [syncMutation, syncedAtQuery])
  const toSettings = useCallback(() => {
    navigate("/settings");
  }, [navigate])

  return (
    <div className={styles.settingsMenu}>
      <div style={{display: 'flex', alignItems: 'center', marginRight: '1rem'}}>
        <Button
          size={"small"}
          variation={"learning"}
          label={"Sync now"}
          icon={"sync"}
          loading={loading()}
          onClick={handleSyncClick}
        />
        <Text variation={"subdued"}>Last sync: {syncedAtQuery.data && getDistance(new Date(syncedAtQuery.data))}</Text>
      </div>
      <Text>{user.accountName}</Text>
      <div style={{ marginRight: "var(--space-smaller)" }}>
        <Menu
          activator={
            <Button
              type="tertiary"
              variation="subtle"
              ariaLabel="settings"
              icon="cog"
            />
          }
          items={[
            {
              actions: [
                {
                  label: "Settings",
                  icon: "cog",
                  onClick: toSettings,
                },
                {
                  label: "Log out",
                  icon: "logout",
                  onClick: handleLogout,
                }
              ],
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Settings;
